import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./formattedUrlCell.html";
class FormattedUrlCell extends LightningElement {
  constructor() {
    super();
    this.label = void 0;
    this.data = void 0;
    this.name = void 0;
    this.developerName = void 0;
    this.isModalOpen = false;
    this.selectedDependencyRows = [];
    this.handleDependencyModal = () => {
      this.isModalOpen = true;
      const selectedSourceRowsEvent = new CustomEvent('selecteddeprows', {
        detail: this.data,
        bubbles: true,
        composed: true
      });
      this.dispatchEvent(selectedSourceRowsEvent);
    };
    this.closeDependencyModal = () => {
      this.isModalOpen = false;
    };
    this.selectedRowsIds = event => {
      const rowIds = event.detail;
      if (rowIds && rowIds.length > 0) {
        this.selectedDependencyRows = rowIds;
      } else {
        this.selectedDependencyRows = [];
      }
    };
    window.addEventListener('selecteddependencyrowids', this.selectedRowsIds.bind(this));
  }
}
_registerDecorators(FormattedUrlCell, {
  publicProps: {
    label: {
      config: 0
    },
    data: {
      config: 0
    },
    name: {
      config: 0
    },
    developerName: {
      config: 0
    }
  },
  fields: ["isModalOpen", "selectedDependencyRows", "handleDependencyModal", "closeDependencyModal", "selectedRowsIds"]
});
export default _registerComponent(FormattedUrlCell, {
  tmpl: _tmpl
});